class DiscountPill extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("submit", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const button = form.querySelector('button[type="submit"]');

    if (!button) return;

    // Get discount code from button attributes
    const discountCode = button.getAttribute("data-discount-code");

    if (!discountCode) {
      console.error("Missing discount code");
      return;
    }

    try {
      // Submit the discount form
      const formData = new FormData(form);
      const response = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        console.warn("Could not apply discount code automatically");
      }

      // Then trigger the regular add to cart button
      let addToCartButton = document.querySelector(
        '.product-form__submit[name="add"]'
      );
      if (!addToCartButton) {
        addToCartButton = this.closest(".product-card").querySelector(
          '.btn-quick-add[name="add"]'
        );
      }
      if (addToCartButton) {
        addToCartButton.click();
      } else {
        throw new Error("Add to cart button not found");
      }
    } catch (error) {
      console.error("Error applying discount:", error);

      // Still try to add to cart even if discount fails
      const addToCartButton = document.querySelector(
        '.product-form__submit[name="add"]'
      );
      if (addToCartButton) {
        addToCartButton.click();
      }
    }
  }
}

customElements.define("discount-pill", DiscountPill);
